/* 99 Sheep Co. scroll motion engine (no dependencies, ~3 KB).
   [data-ns-scene]            a tall section with a .ns-sticky child; its scroll progress p runs 0→1
   [data-ns-range="a,b"]      inside a scene: gets --t = smoothstep((p-a)/(b-a))
   [data-ns-view="len,lag"]   in normal flow: gets --t as it travels `len` px into the viewport (after `lag` px)
   [data-ns-count="100"]      shows round(--t × target)
   .ns-words                  headline that arrives word by word when it scrolls into view
   [data-ns-hook="name"]      calls NS.hooks[name](el) after each update                                  */
(function () {
  if (window.NS && window.NS.ready) { window.NS.refresh(); return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var ease = function (t) { return t * t * (3 - 2 * t); };
  var pair = function (s, d1, d2) { var a = (s || '').split(','); return [parseFloat(a[0]) || d1, parseFloat(a[1]) || d2]; };
  var NS = window.NS = { ready: true, hooks: {}, items: [] };

  function setT(el, t) {
    if (el.__t === t) return;
    el.__t = t;
    el.style.setProperty('--t', t.toFixed(4));
    var target = el.getAttribute('data-ns-count');
    if (target !== null) el.textContent = Math.round(t * parseFloat(target));
  }

  function update() {
    var vh = window.innerHeight, scenes = [], views = [], i;
    /* read pass: all layout reads first, so the browser lays out once per frame */
    document.querySelectorAll('[data-ns-scene]').forEach(function (scene) {
      scenes.push([scene, scene.getBoundingClientRect().top, scene.offsetHeight]);
    });
    document.querySelectorAll('[data-ns-view]').forEach(function (el) {
      views.push([el, el.classList.contains('ns-loaded') ? null : el.getBoundingClientRect().top]);
    });
    /* write pass */
    for (i = 0; i < scenes.length; i++) {
      var scene = scenes[i][0], top = scenes[i][1], total = scenes[i][2] - vh;
      var p = total > 0 ? clamp(-top / total) : (top < vh * 0.5 ? 1 : 0);
      scene.style.setProperty('--p', p.toFixed(4));
      scene.__p = p;
      scene.querySelectorAll('[data-ns-range]').forEach(function (el) {
        var ab = pair(el.getAttribute('data-ns-range'), 0, 1);
        setT(el, ease(clamp((p - ab[0]) / (ab[1] - ab[0] || 1))));
      });
    }
    for (i = 0; i < views.length; i++) {
      var el = views[i][0];
      if (views[i][1] === null) { setT(el, 1); continue; }
      var lp = pair(el.getAttribute('data-ns-view'), 260, 0);
      setT(el, ease(clamp((vh * 0.92 - views[i][1] - lp[1]) / lp[0])));
    }
    document.querySelectorAll('[data-ns-hook]').forEach(function (el) {
      var fn = NS.hooks[el.getAttribute('data-ns-hook')];
      if (fn) fn(el);
    });
  }

  /* measurements that only change on resize or section reload */
  function measure() {
    document.querySelectorAll('[data-ns-hook="six"]').forEach(function (el) {
      var track = el.querySelector('.ns-six-track'), view = el.querySelector('.ns-six-viewport') || el;
      if (!track) return;
      var travel = Math.max(0, track.scrollWidth - view.clientWidth);
      el.__travel = travel; el.style.setProperty('--travel', travel + 'px');
    });
  }

  var queued = false;
  function onScroll() { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; update(); }); } }

  function splitWords(root) {
    if (root.__split) return; root.__split = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span'); s.className = 'ns-w'; s.style.setProperty('--i', i++); s.textContent = part; frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) walk(n);
      });
    })(root);
  }

  var io = null;
  function initWords() {
    var els = document.querySelectorAll('.ns-words:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.35 });
    els.forEach(function (e) { if (e.__obs) return; e.__obs = true; splitWords(e); io.observe(e); });
  }

  NS.refresh = function () {
    measure();
    if (reduce) {
      document.querySelectorAll('.ns-root').forEach(function (r) { r.classList.add('ns-reduced'); });
      document.querySelectorAll('[data-ns-range],[data-ns-view]').forEach(function (el) { setT(el, 1); });
      document.querySelectorAll('[data-ns-hook]').forEach(function (el) { var fn = NS.hooks[el.getAttribute('data-ns-hook')]; if (fn) fn(el); });
    } else update();
    initWords();
  };

  /* Signature Six: horizontal travel distance + active card + counter */
  NS.hooks.six = function (el) {
    var track = el.querySelector('.ns-six-track'), mover = el.querySelector('.ns-six-move');
    if (!track || !mover) return;
    var view = el.querySelector('.ns-six-viewport') || el;
    var cards = track.children, n = cards.length;
    var t = typeof mover.__t === 'number' ? mover.__t : 1;
    var idx = n > 1 ? Math.round(t * (n - 1)) : 0;
    if (window.matchMedia('(max-width: 749px)').matches) {
      var best = 0, bd = 1e9, cx = view.getBoundingClientRect().left + view.clientWidth / 2;
      for (var i = 0; i < n; i++) { var b = cards[i].getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - cx); if (d < bd) { bd = d; best = i; } }
      idx = best;
    }
    if (el.__idx !== idx) {
      el.__idx = idx;
      for (var k = 0; k < n; k++) cards[k].classList.toggle('is-active', k === idx);
      var c = el.querySelector('.ns-six-count'); if (c) c.textContent = ('0' + (idx + 1)).slice(-2) + ' / ' + ('0' + n).slice(-2);
      var bar = el.querySelector('.ns-six-bar i'); if (bar) bar.style.transform = 'scaleX(' + (n > 1 ? idx / (n - 1) : 1) + ')';
    }
  };

  /* Journey: light the nodes the rail has reached */
  NS.hooks.journey = function (el) {
    var rail = el.querySelector('.ns-rail-fill'); if (!rail) return;
    var t = typeof rail.__t === 'number' ? rail.__t : 1;
    el.querySelectorAll('.ns-node').forEach(function (n, k, all) {
      n.classList.toggle('is-lit', t >= k / Math.max(1, all.length - 1) - 0.001);
    });
  };

  /* keyboard: tabbing to an off-screen Signature Six card scrolls the page to the point where that card is centred */
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest('.ns-six-card'); if (!card || reduce) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;
    var scene = card.closest('[data-ns-hook="six"]'), view = scene && scene.querySelector('.ns-six-viewport');
    if (!scene) return;
    if (view) view.scrollLeft = 0;
    var cards = Array.prototype.slice.call(card.parentNode.children), n = cards.length, i = cards.indexOf(card);
    var mover = scene.querySelector('[data-ns-range]'), ab = pair(mover && mover.getAttribute('data-ns-range'), 0.12, 0.9);
    var target = n > 1 ? i / (n - 1) : 0;
    /* invert smoothstep approximately with a few bisection steps */
    var lo = 0, hi = 1; for (var k = 0; k < 20; k++) { var mid = (lo + hi) / 2; if (ease(mid) < target) lo = mid; else hi = mid; }
    var p = ab[0] + lo * (ab[1] - ab[0]);
    var top = scene.getBoundingClientRect().top + window.scrollY;
    window.scrollTo(0, top + p * (scene.offsetHeight - window.innerHeight));
  });

  function boot() {
    NS.refresh();
    if (!reduce) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { NS.refresh(); });
  window.addEventListener('load', function () { NS.refresh(); });
})();